import TERMS_AND_PRIVACY_URLS from '../utils/constants/termsAndPrivacyUrls'

const el = {
  ra: {
    notification: {
      genericError: 'Ουπς, κάτι πήγε στραβά',
      loginError: 'Κάτι πήγε στραβά, παρακαλώ ξαναπροσπαθήστε',
      deleteSuccess: 'Διαγράφηκε επιτυχώς',
      deleteError: 'Προέκυψε κάποιο σφάλμα κατά τη διαγραφή',
      created: 'Δημιουργήθηκε Επιτυχώς',
      updated: 'Ενημερώθηκε Επιτυχώς',
      updatedError: 'Προέκυψε κάποιο σφάλμα κατά την ενημέρωση',
      item_doesnt_exist: 'Το στοιχείο δεν υπάρχει πλέον',
      noNotifications: 'Δεν Υπάρχουν Ειδοποιήσεις.',
      invitation: 'Πρόσκληση',
      billing: 'Tιμολόγηση',
      serverError: 'Αδυναμία φόρτωσης ειδοποιήσεων.',
    },
    invitation: {
      pending: 'Έχετε μια εκκρεμή πρόσκληση για να εγγραφείτε στον σύλλογο',
    },
    billing: {
      billingPeriodEnding: '',
      billingPeriodEnded: '',
    },
    validationErrors: {
      inValidEmail: 'Παρακαλώ, εισάγετε ένα έγκυρο e-mail',
      password: 'Πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες.',
      confirmPassword: 'Οι κωδικοί πρόσβασης πρέπει να ταιριάζουν',
      terms: 'Απαιτείται αποδοχή όρων & προϋποθέσεων',
      requiredField: 'Υποχρεωτικό πεδίο',
      fromDate: 'Η ημερομηνία έναρξης ενός livestream event δεν μπορεί να είναι στο παρελθόν.',
      startTime: 'Η ώρα έναρξης ενός livestream event δεν μπορεί να είναι στο παρελθόν.',
      endTime:
        'Η ώρα λήξης ενός livestream event δεν μπορεί να έχει μικρότερη διάρκεια απο 30 λεπτά.',
      courtId: 'Το πεδίο γήπεδο είναι υποχρεωτικό σε ένα livestream event.',
      threeLetter: 'Το αναγνωριστικό ονόματος πρέπει να είναι 3 γράμματα.',
    },
    message: {
      invalid_form: 'ΜΗ ΕΓΚΥΡΗ ΦΟΡΜΑ',
      not_found: 'Η σελίδα που αναζητήσατε δεν υπάρχει',
    },
    auth: {
      logout: 'Έξοδος',
      auth_check_error: 'Authorization Error',
    },
    page: {
      dashboard: 'Πίνακας Ελέγχου',
      login: 'Σύνδεση',
      signUp: 'Εγγραφή',
      terms: 'Όροι & Προϋποθέσεις',
      forgotPassword: 'Ξέχασα τον κωδικό μου',
      resetPassword: 'Επαναφορά κωδικού',
      profile: 'Προσωπικά Στοιχεία',
      orgSettings: 'Στοιχεία του συλλόγου',
      security: 'Ασφάλεια',
      preferences: 'Ρυθμίσεις',
      edit: 'ΕΠΕΞΕΡΓΑΣΙΑ',
      list: 'ΛΙΣΤΑ',
      create: 'ΔΗΜΙΟΥΡΓΙΑ',
      not_found: 'Η σελίδα δεν βρέθηκε',
      show: 'ΠΡΟΒΟΛΗ',
      yourPlan: 'ΠΛΑΝΟ',
      payments: 'ΠΛΗΡΩΜΕΣ',
      billingDetails: 'ΛΕΠΤΟΜΕΡΕΙΕΣ ΧΡΕΩΣΗΣ',
      distribution: 'Διανομή',
    },
    text: {
      team1: 'Ομάδα 1',
      team2: 'Ομάδα 2',
      teamsOfThree: 'Ομάδες των τριων',
      teamsOfFour: 'Ομάδες των τεσσάρων',
      teamsOfFive: 'Ομάδες των πέντε',
      players: 'ΠΑΙΚΤΕΣ',
      playersSmall: 'Παίκτες',
      selectedPlayers: 'Παίκτες',
      downloadRecording: 'Λήψη Βίντεο',
      notMobileOptimised: 'Η σελίδα δεν είναι ακόμα βελτιστοποιημένη για κινητές συσκευές.',
      tryDesktop: 'Δοκιμάστε την σε υπολογιστή ή tablet!',
      invitedBy: 'πρόσκληση από %{name}',
      nothingPlanned: 'Δεν υπάρχει πρόγραμμα',
      nothingPlannedIn: 'Δεν υπάρχει πρόγραμμα τον %{month}',
      noPendingInvitations: 'Δεν έχετε εκκρεμείς προσκλήσεις.',
      mobileAvailablePages: 'Από το κινητό σας μπορείτε να δείτε το Ημερολόγιο και να διαχειριστείτε το Προφίλ σας.',
      emailConfirm: 'Παρακαλώ πατήστε το κουμπί για να επιβεβαιώσετε το email',
      createOrg: 'Δημιούργησε τον πρώτο σου σύλλογο',
      orgAvatar: 'Εικονίδιο συλλόγου',
      deleteEventPrompt: 'Διαγραφή αυτού του event;',
      description: 'Περιγραφή',
      publish: 'Δημοσιεύμενο',
      tags: 'Ετικέτες',
      viewMore: 'ΔΕΙΤΕ ΠΕΡΙΣΣΟΤΕΡΑ',
      backToOrg: 'Πίσω στο Organisation',
      text: 'Κείμενο',
      createNew: 'Δημιουργία',
      minutes: 'Λεπτά',
      activity: 'Δραστηριότητα',
      notes: 'Σημειώσεις',
      removePlan: 'Αφαίρεση Πλάνου',
      min: 'min',
      changeEmail: 'Τροποποίηση email',
      insertNewEmail: 'Εισάγετε το καινούργιο email και το κωδικό πρόσβασης',
      changePhoneNumber: 'Τροποποίηση αριθμού τηλεφώνου',
      insertNewPhoneNumber: 'Εισάγετε το καινούργιο αριθμό τηλεφώνου και το κωδικό πρόσβασης',
      disableAccount: 'Είστε σίγουροι ότι θέλετε να διαγράψετε τον λογαριασμό σας;',
      insertPassword: 'Εισάγετε τον κωδικό πρόσβασης για να διαγράψετε τον λογαριασμό σας',
      closeAccount: 'Διαγραφή λογαριασμού',
      disableAccountDataLost: 'Εάν διαγράψετε τον λογαριασμό σας, όλα τα δεδομένα σας θα χαθούν.',
      deleteOrg: 'Είστε σίγουροι ότι θέλετε να γίνει διαγραφή του συλλόγου;',
      deleteOrgName: 'Παρακαλώ γράψτε το όνομα του συλλόγου που θέλετε να διαγράψετε',
      deleteTeam: 'Είστε σίγουροι ότι θέλετε να γίνει διαγραφή της ομάδας;',
      deleteTeamName: 'Παρακαλώ γράψτε το όνομα της ομάδας που θέλετε να διαγράψετε',
      pendingEmail: 'Email(s) σε εκκρεμότητα',
      forgotPassword:
        'Παρακαλώ γράψτε το email σας για να λάβετε ένα σύνδεσμο επαναφοράς κωδικού πρόσβασης',
      noCurrentTeams: 'Δεν υπάρχουν διαθέσιμες ομάδες',
      graphics: 'Συστήματα',
      courts: 'Γήπεδα',
      courtsList: 'Λίστα των γηπέδων σας',
      orgUsersList: 'Διαχείριση χρηστών και προσκλήσεων',
      invitationsList: 'Λίστα των εκκρεμών προσκλήσεων σου',
      signUpInvitedEmailLocked: 'Σε αυτή τη διεύθυνση στάλθηκε η πρόσκλησή σας.',
      emptyCourts: 'Δεν υπάρχουν διαθέσιμα γήπεδα',
      emailSent: 'Σας έχει σταλεί email επιβεβαίωσης!',
      confirmingEmail: 'Επιβεβαίωση του email σας...',
      deleteOrgInfo: 'Σβήνοντας το συλλόγου διαγράφονται όλες οι ομάδες και όλα τα μέλη.',
      passOwnershipInfo:
        'Μεταβιβάζοντας την ιδιοκτησία του συλλόγου, μεταβιβάζετε όλα τα δικαιώματα επεξεργασία χρηστών και πληρωμών σε άλλο μέλος του συλλόγου.',
      passOwnershipSuccess: 'Η αίτηση στάλθηκε! Περιμένετε για τον χρήστη να την αποδεκτεί.',
      managePlayers: 'Διαχειριστείτε τα μέλη της ομάδας σας',
      stopLivestream: 'Είστε σίγουρος ότι θέλετε να σταματήσετε το τρέχον livestream;',
      startLivestream: 'Είστε σίγουρος ότι θέλετε να ξεκινήσετε το τρέχον livestream;',
      oneStreamLive: '1 ζωντανή μετάδοση',
      streamsLive: '%{count} ζωντανές μεταδόσεις',
      startingStream: 'Έναρξη μετάδοσης…',
      stoppingStream: 'Διακοπή μετάδοσης…',
      stopThisStream: 'Διακοπή αυτής της μετάδοσης;',
      broadcasting: 'Ζωντανή μετάδοση',
      recordingOnly: 'Μόνο εγγραφή',
      addTeamText: 'Δημιουργήστε Ομάδα',
      recent: 'ΠΡΟΣΦΑΤΑ',
      request: 'ΑΙΤΗΣΗ',
      teamSettings: 'Ρυθμίσεις ομάδας',
      manageOrgTeams:
        'Διαχειριστείτε τις ομάδες του συλλόγου σας, τις πληροφορίες και τις κατηγορίες τους',
      noRecentLivestream: 'Δεν υπάρχουν πρόσφατα livestreams!',
      inviteUsers: 'Προσάλεσε χρήστες',
      setRoles: 'Ορισμός ρόλων',
      deleteOrgUser: 'είστε σίγουρος ότι θέλετε να αφαιρέσετε αυτόν τον χρήστη από το σύλλογο;',
      doubleInviteError: 'Δεν μπορείτε να προσθέσετε το ίδιο email δυο φορές!',
      deleteInvitationConfirmation:
        'Είστε σίγουρος ότι θέλετε να αρνηθείτε την πρόσκληση από τον χρήστη ',
      passOwnership: 'Μεταβίβαση ιδιοκτησίας του συλλόγου',
      paymentSuccess: 'Επιτυχής Πληρωμή',
      changeCardSuccess: 'Επιτυχής αλλαγή κάρτας',
      paymentFail: 'Αποτυχία Πληρωμής',
      changeCardFail: 'Αποτυχία αλλαγής κάρτας',
      addingNewUser: 'Προσθήκη νέου χρήστη;',
      addingNewUserText:
        'Η πρόσκληση χρηστών είναι δωρεάν και δεν υπάρχει όριο στον αριθμό τους.',
      removingUser: 'Αφαίρεση χρήστη;',
      removingUserText:
        'Η αφαίρεση ενός χρήστη δεν επηρεάζει τη χρέωσή σας.',
      getInvoice: 'Πως μπορώ να λάβω τιμολόγιο;',
      getInvoiceText:
        'Αν έχετε προσθέσει όλες τις απαραίτητες λεπτομέριες, θα λάβετε τιμολόγιο εντός 24 ωρών μέσω email.',
      contactYou: 'Πως μπορώ να επικοινωνήσω μαζί σας;',
      contactYouText:
        'Για οποιαδίποτε πληροφορία σχετικά με την τιμολόγηση και τις συνδρομές, επικοινωνήστε μαζί μας στο accounting@mismatch.gr',
      orgSubscription: 'Συνδρομή',
      activateOrgSubscription: 'Τα Addons σου.',
      faq: 'Συνηθεις Ερωτήσεις',
      subscriptionSummary: 'Σύνοψη',
      outstanding: 'εκκρεμές',
      outstandingCharges: 'Εκκρεμείς Χρεώσεις',
      outstandingChargesDescription: 'Έχετε απλήρωτες χρεώσεις από προηγούμενη περίοδο χρέωσης.',
      outstandingTotal: 'Σύνολο Εκκρεμών',
      activate: 'ΕΝΕΡΓΟΠΟΙΗΣΗ',
      reActivateOrgSubscription: 'Ενεργοποίηση ξανά συνδρομής στο Σύλλογου ασς',
      subscription: 'Συνδρομή',
      monthly: 'Μηνιαία',
      noTransactions: 'Δεν βρέθηκαν πληρωμές!',
      addANote: 'Προσθέστε σημείωση',
      orgMembers: 'ΧΡΗΣΤΕΣ ΣΥΛΛΟΓΟΥ',
      scoreboardSourceInfo:
        'Από πού προέρχεται το σκορ που εμφανίζεται στη μετάδοση. Εμφανίζονται μόνο οι πηγές που μπορεί να τροφοδοτήσει το γήπεδο και το πλάνο μετάδοσης.',
      gameStateTrackingInfo:
        'Tο ακόλουθο πεδίο διαχειρίζεται τον έλεγχο της ανίχνευσης καταστάσεων του stream σας. Μπορείτε να το βάλετε σε ασυτόματη λειτουργία, να το ελεγξετε οι ίδιοι μέσω της streaming εφαρμογής μας ή να το απενεργοποιήσετε εντελώς.',
      uploadVideoInfo:
        'Τα βίντεο θα πρέπει να είναι αρκετά μικρα για να προβάλλονται στα διαλείμματα και το μέγεθος τους να μην υπερβαίνει τα 20Mb.',
      stillUploading:
        'Υπάρχουν ακόμα video που ανεβαίνουν, αν θες να δημιουρήσεις το παιχνίδι δεν θα αποθηκευτούν!',
      completed: 'Ολοκληρώθηκε',
      addTeamFirst: 'Πρέπει πρώτα να προσθέσεις ομάδα!',
      youHave: 'Έχετε ',
      pendingInvitation: ' εκκρεμείς προσκλήσεις',
      emptyCourtsList: 'Δεν έχουν δημιουργηθεί ακόμα γήπεδα!',
      noOptionsAvailable: 'Μη διαθέσιμες επιλογές',
      createNewCourt: 'Δημιουργήστε καινούργιο γήπεδο',
      inviteByEmail: 'Ή καλέστε με email:',
      ownershipRequested: 'Έχετε προσκαλέσει τον ',
      toBecomeOwner: ' να γίνει ιδιοκτήτης του συλλόγου.',
      invitations: 'Προσκλήσεις',
      OrgUsers: 'Χρήστες ανά σύλλογο',
      apps: 'Εφαρμογές',
      integrations: 'Ενσωματώσεις',
      manageIntegrations: 'Διαχειριστείτε τις εφαρμογές σας',
      widgets: 'Widgets',
      widgetsSubtitle:
        'Ενσωματώστε ζωντανά στατιστικά στην ιστοσελίδα σας. Αντιγράψτε ένα από τα παρακάτω snippets και επικολλήστε το στη σελίδα σας.',
      widgetsDocsLink: 'Δείτε την πλήρη τεκμηρίωση των widgets.',
      widgetsRequireStats:
        'Τα widgets είναι διαθέσιμα μόνο αν είναι ενεργοποιημένο το addon Stats.',
      competitionWidget: 'Διοργάνωση',
      boxscoreWidget: 'Boxscore',
      competitionLiveScoreWidget: 'Ζωντανά αποτελέσματα διοργάνωσης',
      copy: 'Αντιγραφή',
      copied: 'Αντιγράφηκε!',
      youtubeIntegrationText:
        'Μπορείτε να συνδέσετε το σύλλογο σας με το κανάλι σας στο YouTube για να διευκολύνετε την οργάνωση livestream. Αυτή η σύνδεση θα δημιουργεί αυτόματα τα broadcast στο YouTube, για να μην χρειάζεται να το κάνετε εσείς.',
      youtubeIntegrationInfo: `Η χρήση και η μεταφορά πληροφοριών που λαμβάνονται από τις υπηρεσίες API της Google σε οποιαδήποτε άλλη εφαρμογή θα συμμορφώνεται με την <a href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes" target="_blank">Πολιτική Χρήστη Δεδομένων των Υπηρεσιών API της Google</a>, συμπεριλαμβανομένων των απαιτήσεων Περιορισμένης Χρήσης.`,
      linkYoutubeChannel: 'Συνδέστε κανάλι YouTube',
      youtubeReconnectRequired:
        'Το YouTube δεν δέχεται πλέον αυτή τη σύνδεση. Επανασυνδέστε το κανάλι για να συνεχίσετε τις μεταδόσεις.',
      youtubeReconnectRequiredForBroadcast:
        'Το κανάλι σας στο YouTube δεν είναι διαθέσιμο ως προορισμός, επειδή η σύνδεση έληξε.',
      reconnectOnIntegrations: 'Επανασυνδέστε το από τη σελίδα Ενσωματώσεις',
      unlink: 'Αποσύνδεση',
      contentChildren: 'Περιεχόμενο κατάλληλο για παιδιά:',
      promotionalContent: 'Περιέχει περιεχόμενο προώθησης',
      liveChat: 'Ζωντανή συζήτηση',
      liveChatReplay: 'Επανάληψη ζωντανής συζήτησης',
      liveChatParticipants: 'Συμμετέχοντες ζωντανής συζήτησης',
      liveChatReactions: 'Αντιδράσεις ζωντανής συζήτησης',
      useYoutube: 'Χρησιμοποίησε το κανάλι YouTube του συλλόγου',
      differentYoutubeChannel: 'Χρησιμοποιείστε κλειδί αναμετάδωσεις URI',
      youtubeChannelTab: 'Το YouTube σας',
      streamKeyTab: 'Προσαρμοσμένο RTMP',
      enterThumbnail: 'Ανεβάστε Thumbnail του video',
      thumbnailEdit: 'Η εικόνα του βίντεο δεν πρέπει να υπερβαίνει τα 2MB',
      enableStats: 'Ενεργοποίηση Στατιστικών',
      autofollowEnabled: 'Αυτόματη Κίνηση',
      streamNotStarted: 'Το stream δεν έχει αρχίσει ακόμα. Παρακαλώ περιμένετε.',
      profileSettingsSub: 'Διαχειρίσου τις προσωπικές σου πληροφορίες',
      billingDetails: 'Λεπτομέριες Πληρωμής',
      needInvoice: 'Είστε εταιρεία; Χρειάζεστε τιμολόγιο;',
      removeVideo: 'Είστε σίγουρος ότι θέλετε να αφαιρέσετε αυτό το βίντεο από το πρόγραμμα;',
      bigFileAdded: 'Το αρχείο είναι μεγαλύτερο από 20Mb',
      orgOwner:
        'Είστε ο ιδιοκτήτης του συλλόγου. Η διαγραφή του λογαριασμού σας θα οδηγήσει στη διαγραφή όλων των συλλόγων που κατέχετε.',
      cancelSubscriptionConfirmation: 'Είστε σίγουρος ότι θέλετε να ακυρώσετε την συνδρομη σας;',
      period: 'Περίοδος',
      quarter: 'Π',
      youAreAdding: 'Προσθέτεις',
      at: 'για',
      month: 'μήνα',
      unauthorizedPageHeader:
        'Φαίνεται πως σε κάθισαν στον πάγκο, ας σε επιστρέψουμε στο παιχνίδι!',
      unauthorizedPageMain:
        'Επικοινώνησε με τον ιδιοκτήτη του συλλόγου για να τσεκάρεις την κατάσταση της εγγραφής ή επικοινώσησε μαζί μας.',
      unauthorizedPaymentHeader: 'Μένει ένα βήμα — κάντε την πρώτη πληρωμή για να ξεκινήσετε.',
      unauthorizedPaymentMain:
        'Ο οργανισμός σας είναι έτοιμος και η τιμή έχει συμφωνηθεί. Ολοκληρώστε τη συνδρομή σας για την πρώτη πληρωμή και ξεκλειδώστε τα πάντα.',
      cardSavedSubscribe:
        'Η κάρτα αποθηκεύτηκε — πατήστε Εγγραφή για να ενεργοποιήσετε τη συνδρομή σας',
      unauthorizedTooltip: 'Δεν έχεις πρόσβαση σην σελίδα. Ελεγξε την συνδρομή του συλλόγου!',
      supportBubbleHeader: 'Έχετε πρόβλημα;',
      supportBubbleText:
        'Ρωτήστε μας ο,τιδήποτε ή ενημερώστε μας για τυχόν προβλήματα που αντιμετοπίζετε!',
      jerseyNumber: 'Αριθμός Φανέλας: ',
      height: 'Ύψος: ',
      positions: 'Θέσεις: ',
      games: 'Παιχνίδια: ',
      allGames: 'Όλα τα Παιχνίδια',
      lastGame: 'Τελευταίο Παιχνίδι',
      last5Games: 'Τελευταία 5 Παιχνίδια',
      last10Games: 'Τελευταία 10 Παιχνίδια',
      seasonStats: 'Στατιστικά Σεζόν',
      gameStats: 'Στατιστικά Παιχνιδιού',
      stats: 'Στατιστικά',
      navGames: 'Παιχνίδια',
      won: 'Νίκες',
      lost: 'Ήττες',
      PIR: 'Δείκτης Απόδοσης, μέτρο της συνολικής στατιστικής απόδοσης ενός παίκτη',
      GP: 'Αγώνες Που Παίχθηκαν',
      GS: 'Αγώνες Που Ξεκίνησαν',
      MIN: 'Λεπτά Που Παίχθηκαν',
      PTS: 'Πόντοι',
      '2P': 'Δίποντο',
      '3P': 'Τρίποντο',
      FT: 'Ελεύθερες Βολές',
      OR: 'Επιθετικά Ριμπάουντ',
      DR: 'Αμυντικά Ριμπάουντ',
      TR: 'Συνολικά Ριμπάουντ',
      AST: 'Ασίστ',
      STL: 'Κλεψίματα',
      TO: 'Λάθη',
      BLK: 'Κοψίματα',
      BLKA: 'Κοψίματα Κατα',
      FC: 'Φάουλ',
      FD: 'Κερδισμένα Φάουλ',
      perQuarter: 'Ανά Περίοδο',
      endOfQuarter: 'Τέλος Περιόδου',
      totalCost: 'Συνολική Τιμή',
      nextBillingDate: 'Επόμενη Χρέωση',
      videoActivation: 'Ενεργοποίηση Βίντεο',
      videoActivationMessage:
        'Μπορείς να ρωτήσεις οτιδήποτε θέλεις να μάθεις σχετικά με τη ροή βίντεο.',
      updateSubscriptionConfirmation: 'Πρόκειται να αναβαθμίσετε τη συνδρομή σας.',
      noActiveAddons:
        'Πρόκειται να αφαιρέσετε το τελευταίο Addon από τη συνδρομή σας. Καθώς αυτό είναι το τελευταίο Addon, η συνδρομή σας θα ακυρωθεί μέχρι να το ενεργοποιήσετε ξανά.',
      addOnActivation: 'Ενεργοποίηση Add-on',
      billingReadOnly:
        'Τα στοιχεία τιμολόγησής σας μπορούν να αλλάξουν μόνο από τη Mismatch. Επικοινωνήστε με το support@mismatch.gr για οποιαδήποτε αλλαγή πέρα από τα στοιχεία της κάρτας σας.',
      billingIncompleteForCheckout:
        'Τα στοιχεία τιμολόγησής σας είναι ελλιπή, οπότε η αγορά δεν μπορεί να ολοκληρωθεί. Επικοινωνήστε με το support@mismatch.gr για να συμπληρωθούν.',
      billingPaymentMessage:
        'Η ύπαρξη ενεργής συνδρομής θα σας οδηγήσει να πληρώσετε μόνο για τον υπόλοιπο μήνα για να ενεργοποιήσετε αυτό το addon.',
      billingPaymentMessageInvite:
        'Η ύπαρξη ενεργής συνδρομής θα σας οδηγήσει να πληρώσετε μόνο για τον υπόλοιπο μήνα για να καλέσετε χρήστες.',

      reactivate: 'ΕΠΑΝΕΝΕΡΓΟΠΟΙΗΣΗ',
      activateCoupon: 'ΕΝΕΡΓΟΠΟΙΗΣΗ ΚΟΥΠΟΝΙΟΥ',
      publishTextA: 'Παρακαλώ βεβαιωθείται πως όλα τα πεδία είναι συμπληρωμένα και το  ',
      publishTextB: ' είναι στα αγγλικά.',
      publishTextC:
        'Το Mismatch έχει το δικαίομα να επεξεργαστεί ή να το αποδημοσιεύει αν θεωρηθεί απαραίτητο',
      mainSubText: 'Επανεγγραφείτε για να αποκτήσετε πρόσβαση στα ενεργοποιημένα addon.',
      addonType: 'Addon',
      totalPrice: 'Συνολική Τιμή',
      socialConfMvp: 'Αναρτηση MVP αγώνα',
      socialConfAnnouncement: 'Αναρτηση ανακοίνωσης αγώνα',
      socialConfQuarter: 'Αναρτηση ανακοίνωσης δεκάλεπτου αγώνα',
      socialConfResult: 'Αναρτηση ανακοίνωσης αποτελέσματος αγώνα',
      socialConfBackground: 'Φόντο ανακοινώσεων',
      noAccounts: 'Δε Βρέθηκαν Λογαριασμοί',
      share: 'Κοινοποίηση',
      copyToClipBoard: 'Η διεύθυνση URL αντιγράφηκε στο πρόχειρο!',
      didNotPlay: 'Δεν Έπαιξε',
      score: 'Ζωντανό αποτέλεσμα',
      upcoming: 'Επερχόμενος',
      final: 'Τελικό Αποτέλεσμα',
      postponed: 'Αναβολή',
      forfeit: 'Μηδενισμός',
      continueWithFB: 'Continue with Facebook',
      metaConnected: 'Συνδέθηκε: %{platforms}',
      metaIntegrationText:
        'You can connect your organisation with you Facebook account to automate the posting on your Facebook and Instagram feed. For every game you create, you get posts for game announcement, game mvp, game result and quarter result!',
      emailNotifications:
        'Η εγγραφή σας ετοιμάζεται. Σύντομα θα λάβετε ένα email με τον σύνδεσμο λήψης.',
      gameSummaryNotification:
        'Η περίληψη του παιχνιδιού σας είναι έτοιμη. Θα λάβετε ένα email για να τη κατεβάσετε.',
      downloadSummary: 'Λήψη Περίληψης',
      overlayLinks: 'Λήψη Συνδέσμων Overlay',
      fansConfig: 'Ρυθμίσεις Fans',
      isFansEnabled: 'Ενεργοποίηση Fans',
      fansChannels: 'Κανάλια Διοργανώσεων',
      fansChannelsHint:
        'Ενεργοποιήστε ή απενεργοποιήστε το κανάλι Fans για κάθε διοργάνωση. Οι αλλαγές αποθηκεύονται αυτόματα.',
      competition: 'Διοργάνωση',
      fansEnabled: 'Ενεργοποιημένα Fans',
      noCompetitions:
        'Δεν υπάρχουν διοργανώσεις ακόμα. Δημιουργήστε μια διοργάνωση για να ενεργοποιήσετε ένα κανάλι Fans.',
      integrationRequiresAddon: 'Απαιτείτε ενεργοποίηση του ακόλουθου προσθέτου %{addon}',
      socialChannelsHint:
        'Συνδέστε έναν λογαριασμό Meta (Facebook / Instagram) ανά διοργάνωση. Το PicknPost δημοσιεύει στον συνδεδεμένο λογαριασμό.',
      metaAccount: 'Λογαριασμός Meta',
      connect: 'Σύνδεση',
      chooseAccountToConnect: 'Επιλέξτε έναν λογαριασμό για σύνδεση!',
      noSocialCompetitions:
        'Δεν υπάρχουν διοργανώσεις ακόμα. Δημιουργήστε μια διοργάνωση για να συνδέσετε έναν λογαριασμό social.',
      noOrgTitle: 'Ο λογαριασμός σας δεν είναι συνδεδεμένος με κάποιον σύλλογο',
      noOrgContact: 'Για περισσότερες πληροφορίες επικοινωνήστε με τη Mismatch στο',
      noOrgAppsTitle: 'Θέλετε να δείτε στατιστικά; Κατεβάστε την εφαρμογή μας GameDay',
      noOrgGamedayComment:
        'Παρακολουθήστε αγώνες, ζωντανά σκορ, στατιστικά και play-by-play από το κινητό σας.',
    },
    formFields: {
      firstName: 'Όνομα',
      lastName: 'Επώνυμο',
      email: 'Διεύθυνση Email',
      phoneNumber: 'Αριθμός Τηλεφώνου',
      password: 'Κωδικός',
      oldPassword: 'Παλιός Κωδικός',
      newPassword: 'Νέος Κωδικός',
      confirmPassword: 'Επιβεβαίωση Κωδικού',
      birthday: 'Ημερομηνία Γέννησης',
      acceptTerms: `<span style="color: #E0726E; font-weight: 700">* </span>Έχω διαβάσει & αποδέχομαι τους <a style="color: #E0726E" href="${TERMS_AND_PRIVACY_URLS.TERMS_OF_USE}" target="_blank">όρους χρήσης</a> και <a style="color: #E0726E" href="${TERMS_AND_PRIVACY_URLS.PRIVACY_POLICY}" target="_blank">προστασίας προσωπικών δεδομένων</a>`,
      marketingConsent:
        'Συναινώ στην αποστολή προωθητικών email, newsletter και marketing επικοινωνιών από το Mismatch. (προαιρετικό)',
      dataSharingConsent:
        'Συναινώ στο να μοιραστεί το Mismatch τα στοιχεία επικοινωνίας και τα δεδομένα χρήσης μου (π.χ. διεύθυνση email, αγαπημένες ομάδες, αλληλεπιδράσεις και μετρήσεις) με επιλεγμένους τρίτους συνεργάτες για marketing, διαφήμιση και άλλους εμπορικούς σκοπούς. (προαιρετικό)',
      name: 'Όνομα',
      country: 'Χώρα',
      city: 'Πόλη',
      logo: 'Logo',
      ageGroup: 'Επίλεξε Ηλικία',
      gender: 'Επίλεξε Φύλο',
      shortName: 'Σύντομο Όνομα',
      teamShortName: 'Σύντομο όνομα ομάδας',
      teamName: 'Όνομα Ομάδας',
      teamExternalId: 'Εξωτερικό Id ομάδας',
      eventTitle: 'Όνομα event',
      from: 'Από',
      date: 'Ημερομηνία',
      to: 'Εώς',
      notes: 'Σημειώσεις',
      topic: 'Θέμα',
      place: 'Τοποθεσία',
      startTime: 'Ώρα Έναρξης',
      endTime: 'Ώρα Λήξης',
      location: 'Τοποθεσία',
      opponent: 'Αντίπαλος',
      home: 'Εντός',
      away: 'Εκτός',
      neutral: 'Ουδέτερο',
      court: 'Γήπεδο',
      gym: 'Γυμναστήριο',
      other: 'Άλλο',
      team: 'Ομάδα',
      teams: 'Ομάδες',
      role: 'Ρόλος',
      intensity: 'Ενταση',
      positions: 'Θέσεις',
      title: 'Title',
      courtName: 'Όνομα Γηπέδου',
      homeTeam: 'Γηπεδούχος Ομάδα',
      awayTeam: 'Φιλοξενούμενη ομάδα',
      streamKey: 'Κλειδί ροής',
      streamKeyPlaceholder: 'Επικολλήστε το κλειδί ροής',
      customServerPlaceholder: 'rtmp://your-server/app/stream-key',
      streamKeyURI: 'RTMP URL',
      streamKeyURI2: 'Επιπλέον RTMP URL',
      addAdditionalStreamKey: 'Προσθεσε επιπλέον κλειδί αναμετάδοσης URI',
      youtubeVideoTitle: 'Τίτλος',
      youtubeVisibility: 'Ορατότητα',
      externalBroadcastUrl: 'Εξωτερικός Σύνδεσμος Αναμετάδοσης',
      seasonName: 'Όνομα Σεζόν',
      statsMode: 'Stats Mode',
      OrgRole: 'Ρόλος Συλλόγου',
      userPermissions: 'Άδειες Χρηστή',
      streamVideo: 'Ζωντανή Μετάδοση',
      recordVideo: 'Μόνο Εγγραφή Βίντεο',
      livestreamType: 'Τύπος',
      panoramic: 'Πανοραμικό',
      gameLite: 'Game Lite',
      gameFull: 'Game Full',
    },
    // NOTE: Greek translations below are machine-suggested and may need review by a native speaker.
    gameDrawer: {
      title: 'Αγώνας',
      requiredFields: 'Υποχρεωτικά πεδία',
      statistician: 'Στατιστικολόγος',
      studioOperator: 'Χειριστής στούντιο',
      videoOperator: 'Χειριστές βίντεο',
      sharedRevenue: 'Διαμοιρασμός εσόδων',
      team: 'Ομάδα',
      tabs: {
        details: 'Λεπτομέρειες',
        streaming: 'Ροή',
        stats: 'Στατιστικά',
      },
      sections: {
        matchup: 'Ομάδες',
        destination: 'Προορισμός',
        automation: 'Αυτοματισμός',
        production: 'Παραγωγή',
        ads: 'Διαφημίσεις',
      },
      coverage: {
        off: 'Ανενεργό',
        recordOnly: 'Μόνο εγγραφή',
        livestream: 'Ζωντανή ροή',
      },
      offNote: 'Αυτός ο αγώνας δεν θα μεταδοθεί ούτε θα καταγραφεί.',
      noStreamCourt:
        'Επιλέξτε γήπεδο διαμορφωμένο για μετάδοση για να ρυθμίσετε την κάλυψη αυτού του αγώνα.',
      thirdPartyStreamPrompt: 'Αναμετάδοση μέσω τρίτου παρόχου;',
      automation: {
        autoStart: 'Αυτόματη έναρξη',
        autoStop: 'Αυτόματος τερματισμός',
        autoStartDesc: 'Έναρξη ζωντανής μετάδοσης στην προγραμματισμένη ώρα έναρξης.',
        autoStopDesc: 'Τερματισμός της ροής στο προγραμματισμένο τέλος.',
      },
      addStreamKey: 'Προσθήκη RTMP URL',
      streamToCustomServer: 'Μετάδοση σε προσαρμοσμένο διακομιστή',
      useYoutube: 'Χρήση διακομιστή YouTube',
      scoreboardSource: 'Πίνακας',
      commentary: {
        label: 'Σχολιασμός',
        offSite: 'Εξ αποστάσεως',
        onSite: 'Επί τόπου',
        viaCamera: 'Μέσω κάμερας',
        info: 'Εξ αποστάσεως: σχολιασμός από το Studio, από οπουδήποτε. Επί τόπου: σχολιασμός στο γήπεδο, συγχρονισμένος με την κάμερα, προαιρετικά με μικρόφωνο συνδεδεμένο στην κάμερα.',
      },
      streamEventTracking: 'Παρακολούθηση συμβάντων',
      streamEventTrackingDesc: 'Καταγράψτε χειροκίνητα συμβάντα κατά τη διάρκεια της ροής.',
      stats: {
        trackStats: 'Καταγραφή Στατιστικών',
        trackStatsDesc: 'Ξεκλειδώνει την κατάσταση & τη ζωντανή καταχώριση στατιστικών.',
        lockedNote: 'Ενεργοποιήστε την Καταγραφή Στατιστικών για να ορίσετε στατιστικολόγο.',
      },
      result: {
        section: 'Αποτέλεσμα',
        noResult: 'Δεν έχει καταχωρηθεί αποτέλεσμα',
        final: 'Τελικό σκορ %{score}',
        live: 'Ζωντανά %{score}',
        forfeitBy: 'Μηδενισμός: %{team} (%{reason})',
        setScore: 'Καταχώριση σκορ',
        forfeit: 'Μηδενισμός',
        saveScore: 'Αποθήκευση σκορ',
        recordForfeit: 'Καταχώριση μηδενισμού',
        keepStats: 'Διατήρηση καταγεγραμμένων στατιστικών παικτών',
        keepStatsDesc:
          'Αν απενεργοποιηθεί, όλα τα καταγεγραμμένα στατιστικά του αγώνα (play-by-play, στατιστικά παικτών και ομάδων) διαγράφονται οριστικά.',
        forfeitingTeam: 'Ομάδα που μηδενίζεται',
        reason: 'Αιτία',
        reasonStandard: 'Μη προσέλευση (20-0)',
        reasonLessThan2Players: 'Λιγότεροι από δύο παίκτες (2-0)',
        scoreAtStop: 'Σκορ κατά τη διακοπή (προαιρετικό)',
        scoreAtStopHint: 'Αν η αντίπαλη ομάδα προηγούνταν, ισχύει το καταγεγραμμένο σκορ.',
        confirmScoreTitle: 'Καταχώριση τελικού σκορ;',
        confirmScoreText:
          'Το τελικό σκορ θα οριστεί σε %{score} και ο αγώνας θα κλείσει. Τα στατιστικά ομάδων και η βαθμολογία θα επανυπολογιστούν.',
        confirmReplaceTitle: 'Αντικατάσταση καταγεγραμμένων στατιστικών;',
        confirmReplaceText:
          'Όλα τα καταγεγραμμένα στατιστικά αυτού του αγώνα (play-by-play, στατιστικά παικτών και ομάδων) θα διαγραφούν οριστικά και θα αντικατασταθούν από το σκορ %{score}. Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
        confirmReplaceAgainTitle: 'Είστε σίγουροι;',
        confirmReplaceAgainText:
          'Τα διαγραμμένα στατιστικά δεν μπορούν να ανακτηθούν. Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
        confirmForfeitTitle: 'Καταχώριση μηδενισμού;',
        confirmForfeitText:
          'Θα καταχωρηθεί μηδενισμός της ομάδας %{team} (%{reason}) και ο αγώνας θα κλείσει. Τα στατιστικά ομάδων και η βαθμολογία θα επανυπολογιστούν.',
        continue: 'Συνέχεια',
        confirm: 'Επιβεβαίωση',
        deleteAndReplace: 'Διαγραφή & αντικατάσταση',
        saved: 'Το αποτέλεσμα καταχωρήθηκε',
        invalidScore: 'Εισάγετε έγκυρο σκορ και για τις δύο ομάδες',
        selectTeam: 'Επιλέξτε την ομάδα που μηδενίζεται',
        bothScoresOrNone: 'Συμπληρώστε το σκορ και για τις δύο ομάδες ή αφήστε και τα δύο κενά',
      },
    },
    consentPopup: {
      title: 'Ενημέρωση Όρων Χρήσης',
      subtitle: 'Παρακαλούμε διαβάστε και αποδεχτείτε για να συνεχίσετε στο Mismatch.',
      required: 'ΥΠΟΧΡΕΩΤΙΚΟ',
      optional: 'ΠΡΟΑΙΡΕΤΙΚΟ',
      acceptTermsPrefix: 'Έχω διαβάσει & αποδέχομαι τους',
      termsOfUse: 'όρους χρήσης',
      and: 'και την',
      privacyPolicy: 'πολιτική προστασίας προσωπικών δεδομένων',
      marketingConsent:
        'Συναινώ στην αποστολή προωθητικών email, newsletter και marketing επικοινωνιών από το Mismatch.',
      dataSharingConsent:
        'Συναινώ στο να μοιραστεί το Mismatch τα στοιχεία επικοινωνίας και τα δεδομένα χρήσης μου (π.χ. διεύθυνση email, αγαπημένες ομάδες, αλληλεπιδράσεις και μετρήσεις) με επιλεγμένους τρίτους συνεργάτες για marketing, διαφήμιση και άλλους εμπορικούς σκοπούς.',
      save: 'Αποθήκευση',
    },
    invitationLanding: {
      invitedAs: 'Ο/Η %{sender} σας προσκάλεσε να συμμετάσχετε ως %{role}.',
      invitedToOwn: 'Ο/Η %{sender} σας προσκάλεσε να αναλάβετε αυτόν τον οργανισμό.',
      logInToAnswer: 'Συνδεθείτε για να απαντήσετε',
      createAccountFor: 'Δημιουργήστε τον λογαριασμό σας στο Mismatch με το %{email} για να απαντήσετε.',
      createAccount: 'Δημιουργία λογαριασμού',
      otherAccount:
        'Η πρόσκληση στάλθηκε στο %{receiver}, αλλά είστε συνδεδεμένοι ως %{current}.',
      logOutAndContinue: 'Αποσύνδεση και συνέχεια',
      unavailableTitle: 'Η πρόσκληση δεν είναι διαθέσιμη',
      unavailable:
        'Η πρόσκληση έχει ήδη απαντηθεί ή ανακλήθηκε. Ζητήστε νέα από τον αποστολέα αν χρειάζεστε ακόμη πρόσβαση.',
    },
    kickoffContract: {
      title: 'Σύμβαση οργανισμού',
      subtitle:
        'Πριν αναλάβετε τον οργανισμό, παρακαλούμε διαβάστε και αποδεχτείτε τη σύμβαση παρακάτω.',
      openDocument: 'Άνοιγμα της σύμβασης',
      openInNewTab: 'Άνοιγμα της σύμβασης σε νέα καρτέλα',
      acknowledge: 'Διάβασα τη σύμβαση και αποδέχομαι τους όρους της',
      accept: 'Αποδοχή',
      versionChanged:
        'Η σύμβαση ενημερώθηκε όσο τη διαβάζατε, οπότε η αποδοχή σας δεν καταγράφηκε. Παραπάνω εμφανίζεται η τρέχουσα έκδοση — παρακαλούμε διαβάστε την και αποδεχτείτε ξανά.',
    },
    existingOrgContract: {
      subtitle:
        'Ζητήθηκε από τον οργανισμό σας να υπογράψει τη σύμβαση της Mismatch. Παρακαλούμε διαβάστε την παρακάτω και αποδεχτείτε για να συνεχίσετε.',
    },
    buttons: {
      goToCalendar: 'Ημερολόγιο',
      goToProfile: 'Προφίλ',
      average: 'Μέσος όρος',
      accumulate: 'Συνολικά',
      login: 'ΣΥΝΔΕΣΗ',
      signUp: 'ΕΓΓΡΑΦΗ',
      submit: 'ΕΠΙΒΕΒΑΙΩΣΗ',
      reset: 'ΕΠΑΝΑΦΟΡΑ',
      update: 'ΕΝΗΜΕΡΩΣΗ',
      save: 'Αποθήκευση',
      change: 'ΑΛΛΑΓΗ',
      disableAccount: 'ΔΙΑΓΡΑΦΗ ΛΟΓΑΡΙΑΣΜΟΥ',
      disable: 'ΑΠΕΝΕΡΓΟΠΟΙΗΣΗ',
      add: 'ΠΡΟΣΘΗΚΗ',
      addSmall: 'Προσθήκη',
      upload: 'ΑΝΕΒΑΣΜΑ',
      uploadImage: 'ΑΝΕΒΑΣΜΑ ΕΙΚΟΝΑΣ',
      create: 'ΔΗΜΙΟΥΡΓΙΑ',
      createSmall: 'Δημιουργία',
      newEvent: 'Καινούργιο Event',
      createAndNew: 'ΔΗΜΙΟΥΡΓΙΑ ΚΑΙ ΠΡΟΣΘΗΚΗ',
      addPlayer: 'Προσθήκη Παίχτη',
      invite: 'ΠΡΟΣΚΛΗΣΗ',
      addSeason: 'Προσθήκη Σεζόν',
      addTeam: 'Προσθήκη Ομάδας',
      addRole: 'Προσθήθη Ρόλου',
      editPlayer: 'ΕΠΕΞΕΡΓΑΣΙΑ ΠΑΙΧΤΗ',
      delete: 'ΔΙΑΓΡΑΦΗ',
      cancel: 'ΑΚΥΡΩΣΗ',
      keep: 'Διατήρηση',
      selectTeam: 'Διαλέξτε Ομάδα',
      public: 'ΔΗΜΟΣΙΑ',
      personal: 'ΠΡΟΣΩΠΙΚΑ',
      edit: 'Επεξεργασία',
      showSmall: 'Εμφάνιση',
      hideSmall: 'Απόκρυψη',
      pauseSmall: 'Παύση',
      resumeSmall: 'Συνέχεια',
      stopSmall: 'Διακοπή',
      cancelSmall: 'Ακύρωση',
      stopStream: 'Διακοπή μετάδοσης',
      close: 'ΚΛΕΙΣΙΜΟ',
      remove: 'ΑΦΑΙΡΕΣΗ',
      removeSmall: 'Αφαίρεση',
      resend: 'ΕΠΑΝΑΠΟΣΤΟΛΗ',
      redirectLogin: 'Μετάβαση στην οθόνη login',
      resendMail: 'Αποστολή e-mail ξανά',
      chooseFile: 'ΔΙΑΛΕΞΤΕ ΑΡΧΕΙΟ',
      uploadSeasonLogo: 'LOGO ΓΙΑ ΤHN ΣΕΖΟΝ',
      uploadTeamLogo: 'LOGO ΓΙΑ ΤΗΝ ΟΜΑΔΑ',
      loadRecentSetups: 'Επαναχρήση Ρυθμίσεων',
      select: 'ΕΠΙΛΕΞΤΕ',
      stop: 'ΣΤΑΜΑΤΗΣΤΕ',
      skip: 'ΠΑΡΑΒΛΕΨΗ',
      passOwnership: 'ΑΛΛΑΓΗ ΙΔΙΟΚΤΗΤΗ',
      cancelRequest: 'ΑΚΥΡΩΣΗ ΑΙΤΗΜΑΤΟΣ',
      request: 'YΠΟΒΟΛΗ',
      accept: 'ΑΠΟΔΟΧΗ',
      reject: 'ΑΠΟΡΡΙΨΗ',
      continue: 'ΣΥΝΕΧΕΙΑ',
      tryAgain: 'ΠΡΟΣΠΑΘΕΙΣΤΕ ΞΑΝΑ',
      retry: 'ΕΠΑΝΑΛΗΨΗ',
      changeCard: 'ΑΛΛΑΓΗ ΚΑΡΤΑΣ',
      addCard: 'ΠΡΟΣΘΗΚΗ ΚΑΡΤΑΣ',
      addToPersonal: 'ΠΡΟΣΘΗΚΗ ΣΤΑ ΠΡΟΣΩΠΙΚΑ',
      addToPersonalLower: 'Προσθήκη στα προσωπικά',
      newPractice: 'Καινούργια Προπόνηση',
      export: 'Εξαγωγή',
      watchStream: 'ΔΕΙΤΕ ΜΕΤΑΔΩΣΗ',
      watchVideo: 'Δείτε Βίντεο',
      startVideo: 'Έναρξη Livestream',
      exit: 'ΕΞΟΔΟΣ',
      play: 'PLAY',
      pause: 'PAUSE',
      none: 'ΚΑΝΕΝΑ',
      removeVideo: 'ΑΦΑΙΡΕΣΗ ΤΟΥ ΒΙΝΤΕΟ',
      cancelSubscription: 'ΑΚΥΡΩΣΗ ΣΥΝΔΡΟΜΗΣ',
      no: 'ΟΧΙ',
      activate: 'ΕΝΕΡΓΟΠΟΙΗΣΗ',
      subscribe: 'ΕΓΓΡΑΦΗ',
      completeSubscription: 'Ολοκλήρωση συνδρομής',
      next: 'ΕΠΟΜΕΝΟ',
      payNow: 'ΠΛΗΡΩΜΗ',
      fans: 'FANS',
      social: 'SOCIAL',
      disconnect: 'Αποσύνδεση',
    },
    gridLinks: {
      login: 'Πίσω στην οθόνη Σύνδεσης',
      signUp: 'Κάνε Εγγραφή',
      forgotPassword: 'Ξέχασες τον κωδικό;',
    },
    errorMessages: {
      unknown: '',
      unauthorized: '',
      forbidden: '',
      invalidData: 'Πρέπει να συμπληρώσετε όλα τα υποχρεωτικά πεδία.',
      serviceUnavailable: '',
      badRequest: '',
      s2sConflict: 'Συγνώμη, το email ή ο αριθμός τηλεφώνου χρησιμοποιούνται ήδη.',
      businessError: 'Business Error',
      accountNotFound: 'Συγνώμη, ο λογαριαμός δεν υπάρχει.',
      wrongPassword: 'Συγνώμη, ο λογαριαμός δεν υπάρχει ή ο κωδικός είναι λάθος.',
      emailAccountNotConfirmed: 'Συγνώμη, ο λογαριαμός δεν έχει ενεργοποιηθεί.',
      passwordResetTimeExpired: 'Συγνώμη, το χρονικό όριο επαναφοράς έληξε.',
      passwordNotFound: '',
      tokenNotValid: 'Invalid Token',
      tokenHasBeenUsed: 'Token has been used',
      identityNotFound: '',
      identityAlreadyConfirmed: '',
      identityIsPrimary: '',
      usernameExists: '',
      confirmEmailError: 'Το email δεν επιβεβαιώθηκε.',
      confirmEmailErrorRedirect: 'Μετάβαση στη σελίδα επαναποστολής email επιβεβαίωσης σε',
      emailResentError: 'Αποτυχία αποστολής νέου mail επιβεβαίωσης. Προσπαθήστε πάλι!',
      emailResetPasswordError:
        'Δεν ήταν δυνατή η εύρεση λογαριασμού με το δωθέν email. Παρακαλώ ελέγξτε το email ξανά. Αν πιστεύετε πως υπήρξε κάποιο λάθος, παρακαλώ επικοινωνήστε μαζί μας στο support@mismatch.gr.',
      logosLargePayloadError: 'Συγνώμη, οι εικόνες ξεπερνούν το όριο των 16mb.',
      resetPasswordLinkExpired:
        'Ο σύνδεσμος έχει λήξει ή έχει ήδη χρησιμοποιηθεί — ζητήστε νέο από τη σελίδα «Ξέχασα τον κωδικό μου».',
      passwordBreached:
        'Αυτός ο κωδικός έχει εμφανιστεί σε γνωστή διαρροή δεδομένων. Παρακαλώ επιλέξτε διαφορετικό.',
      resetPasswordError: 'Η επαναφορά κωδικού απέτυχε. Παρακαλώ δοκιμάστε ξανά.',
      autoStartPastStart:
        'Το auto-start δεν μπορεί να ενεργοποιηθεί όταν η ώρα έναρξης είναι στο παρελθόν.',
      startPastAutoStartOn:
        'Η ώρα έναρξης δεν μπορεί να είναι στο παρελθόν όσο το auto-start είναι ενεργό.',
      autoStopPastEnd:
        'Το auto-stop δεν μπορεί να ενεργοποιηθεί όταν η ώρα λήξης είναι στο παρελθόν.',
      endPastAutoStopOn:
        'Η ώρα λήξης δεν μπορεί να είναι στο παρελθόν όσο το auto-stop είναι ενεργό.',
      livestreamMinDuration: 'Το livestream πρέπει να διαρκεί τουλάχιστον 30 λεπτά.',
      serverError: 'Κάτι πήγε στραβά. Προσπαθήστε ξανά.',
      changePasswordError: 'Αποτυχία κατά την ενημέρωση κωδικού.',
      updateTeamError: 'Αποτυχία κατά την ενημέρωση ομάδας. Παρακαλώ προσπαθήστε ξανά!',
      signUpError: 'Λυπάμαι, κάτι πήγε στραβά',
      selfInviteError: 'Δεν μπορείτε να προσκαλέσετε τον εαυτό σας!',
      noUsersToInviteError: 'Δεν προστέθηκαν χρήστες για να προσκληθούν!',
      alreadyOrganisationUserError:
        'Ο χρήστης είναι ήδη μέλος του συλλόγου ή έχει ήδη σταλθεί πρόσκληση!',
      wrongEmailFormat: 'Λάθος μορφή email!',
      invitationSendError: 'Σφάλμα κατά την αποστολή της πρόσκλησης!',
      invitationRejected: 'Απόρριψη πρόσκλησης!',
      maxVideosAdded: 'Δεν μπορείτε να προσθέσετε περισσότερα βίντεο!',
      sameVideosAdded: 'Δεν μπορείτε να προσθέσετε το ίδιο βίντεο!',
      wrong: 'Λάθος κωδικός!',
      errorMessages: 'Κάτι πήγε στραβά.',
      connectionError: 'Παρουσιάστηκε σφάλμα κατά τη φόρτωση των δεδομένων.',
      supportMessageFail: 'Μήνυμα υποστήριξης δεν στάλθηκε επιτυχώς!',
      noStatsAvailable: 'Δεν υπάρχουν διαθέσιμα στατιστικά.',
      noGamesAvailable: 'Δεν υπάρχουν διαθέσιμοι αγώνες.',
      statsGameNotStarted: 'Το παιχνίδι δεν έχει αρχίσει ακόμα.',
    },
    successMessages: {
      accountCreatedLogIn: 'Ο λογαριασμός σας είναι έτοιμος. Συνδεθείτε για να απαντήσετε στην πρόσκληση.',
      forgotPassword: 'Εστάλη email με οδηγίες.',
      resetPassword: 'Ο κωδικός άλλαξε, θα κατευθυνθείτε στην οθόνη Σύνδεσης.',
      emailConfirm: 'Το email επιβεβαιώθηκε, θα κατευθυνθείτε στην οθόνη Σύνδεσης.',
      signUp: 'Ο λογαριασμός σας έχει δημιουργηθεί, θα κατευθυνθείτε στην οθόνη Σύνδεσης.',
      profileData: 'Τα στοιχεία σου ενημερώθηκαν.',
      changePasswordSuccess: 'Ο κωδικός σας ενημερώθηκε επιτυχώς.',
      preferences: 'Οι προτιμήσεις σας ενημερώθηκαν.',
      disableAccount:
        'Ο λογαριασμός σας διαγράφηκε, θα κατευθυνθείτε στην οθόνη Σύνδεσης.',
      confirmEmailSuccess: 'Το email επιβεβαιώθηκε με επιτυχία.',
      emailResent: 'Σας στάλθηκε νέο email επιβεβαίωσης!',
      emailResetPasswordSuccess: 'Σας στάλθηκε νέο email ανάκτησης κωδικού!',
      updateTeamSuccess: 'Η ομάδας σας ενημερώθηκε με επιτυχία!',
      invitationAccepted: 'Αποδοχή πρόσκλησης!',
      supportMessageSuccess: 'Μήνυμα υποστήριξης στάλθηκε επιτυχώς!',
    },
    navigation: {
      skip_nav: 'Μετάβαση στο περιεχόμενο',
      page_rows_per_page: 'Σειρές ανά σελίδα',
      page_range_info: 'Εύρος ανά σελίδα',
      next: 'ΕΠΟΜΕΝΟ',
      no_results: 'ΚΑΝΕΝΑ ΑΠΟΤΕΛΕΣΜΑ',
    },
    action: {
      save: 'Αποθήκευση',
      delete: 'Διαγραφή',
      sort: 'ΤΑΞΙΝΟΜΗΣΗ',
      add_filter: 'Προσθήκη Φίλτρου',
      add_court: 'Προσθήκη Γηπέδου',
      search: 'Αναζήτηση',
      back: 'Επιστροφή',
      refresh: 'Ανανέωση',
      selectAll: 'Επιλογή όλων',
      deselectAll: 'Απεπιλογή όλων',
      cancel: 'Ακύρωση',
    },
    tour: {
      didYouKnow: 'Ήξερες οτι:',
      didYouKnowIntro: '',
      welcome: 'Καλώς ήρθατε στην εφαρμογή Mismatch',
      welcomeIntro:
        'Εξερευνήστε την εφαρμογή για να διαχειριστείτε αποτελεσματικά την ομάδα σας. Έτοιμοι να ξεκινήσετε;',
      organisation: 'Σύλλογος',
      orgIntro:
        'Δημιουργήστε και επεξεργαστείτε συλλόγους, προσκαλέστε άλλα μέλη, δείτε όλους τους συλλόγους στους οποίους είστε μέλος.',
      logo: 'Λογότυπο και Όνομα Ομάδας',
      logoIntro:
        'Το όνομα και το λογότυπο της ομάδας σας. Επισκεφτείτε αυτήν τη σελίδα εύκολα ή ελέγξτε το ημερολόγιο οποτεδήποτε κάνοντας κλικ στο λογότυπο της λέσχης σας.',
      roster: 'Διαχείριση Ομάδας',
      rosterIntro:
        'Χρησιμοποιήστε το ημερολόγιο για να παρακολουθείτε τα γεγονότα της ομάδας, όπως προπονήσεις και αγώνες, και διαχειριστείτε τo <strong>Δυναμικό της Ομάδας</strong>.',
      rosterMan: 'Διαχείριση Ρόστερ',
      rosterManIntro:
        'Διαχειριστείτε απροσπέλαστα το ρόστερ της ομάδας σας εδώ. Προσθέστε, επεξεργαστείτε ή αφαιρέστε παίκτες όπως χρειάζεται.',
      playerList: 'Λίστα Παικτών',
      playerListOntro:
        'Όλοι οι παίκτες της ομάδας αναφέρονται. Ταξινομήστε ανά όνομα, φανέλα, ύψος, ηλικία. Κάντε κλικ σε έναν παίκτη για να επεξεργαστείτε τις λεπτομέρειες.',
      addPlayer: 'Προσθήκη Παίκτη',
      addPlayerIntro:
        'Κάντε κλικ στο <strong>Προσθήκη Παίκτη</strong> για να ενσωματώσετε νέα μέλη στο ρόστερ σας.',
    },
  },
  Password: {
    NotAllowedKeys: 'Invalid password',
  },
  GENERAL_SYSTEM_LANGUAGE: 'Γλώσσα Συστήματος',
  TEMPORAL_DATE_FORMAT: 'Μορφή Ημερομηνίας',
}

export default el
